aztech.use(function (pkg) {
    'use strict';
    pkg.factoryManager.get('app').create({
        name: 'dial-field',
        version: '0.0.1',
        dependencies: ['mod.vue'],
        setup: function (__shared) {
            return __shared;
        },
        init: function (data, __shared) {
            const Vue = __shared.dependencies['mod.vue'];

            const component = Vue.component('az-dial-field', {
                template: `<div class="az-dial-field" :class="{ 'is-searching': isSearching, error }">
    <input class="az-dial-field--input-prefix" type="text" readonly v-model="prefix" />
    <div class="az-dial-field--inputbox">
        <input 
            type="text"
            name="dial"
            autocomplete="off"
            maxlength="6"
            @focus="handleInputFocus"
            @blur="handleInputBlur"
            @keydown.enter.prevent="handleInputEnter"
            @keypress="handleKeyPress"
            @keyup.esc.stop="handleInputBlur"
            @keyup.down="movePointerDown"
            @keyup.up="movePointerUp"
            :value="countryCode"
            v-on:input="$emit('input', $event.target.value)"
            class="az-dial-field--input"
            ref="input"
            readonly
            />
        <div class="az-dial-field--iconbox">
            <svg width="9" height="5" viewBox="0 0 9 5" fill="none" xmlns="http://www.w3.org/2000/svg" class="az-dial-field--icon-arrow" aria-hidden="true">
                <path d="M0.605575 0H8.39443C8.93326 0 9.20267 0.637415 8.82125 1.01097L4.92834 4.82656C4.69222 5.05781 4.30778 5.05781 4.07166 4.82656L0.178747 1.01097C-0.202673 0.637415 0.0667427 0 0.605575 0Z" fill="#646464"/>
            </svg>
        </div>
    </div>
    <div class="az-dial-field--optionsbox" ref="optionsBox">
        <div class="dial-field--search-container">
            <input
                type="text"
                class="dial-field--input-search"
                data-component="dial-field-search"
                v-model="inputSearch">
        </div>
        <div class="dial-field--options" data-optionsbox>
            <div class="az-dial-field--option disabled"
                tabindex="-1"
                v-if="matchingOptions.length === 0"
                key="no-option" >
                Nothing found
            </div>
            <div 
                class="az-dial-field--option"
                tabindex="-1"
                v-else
                v-for="(option, index) in matchingOptions"
                @click="(event) => selectOption(event, option)" 
                :class="{ active: pointer === index}"
                :key="index" 
            >
                <span class="az-dial-field--option--country">{{ option.code2 }} ({{ option.name }})</span> +{{ option.phone }}
            </div>
        </div>
    </div>
</div>
`,
                model: {
                    prop: 'selectValue',
                    event: 'input'
                },
                props: {
                    selectValue: {Object, default(){return {"country_call_code": ""};}},
                    options: { 
                        type: Array, 
                        default: function() {
                            return [];
                        },
                    },
                    error: Boolean
                },
                data: function() {
                    return {
                        isSearching: false,
                        internalChange: false,
                        prefix: null,
                        pointer: -1,
                        countryCode: '',
                        inputSearch: ''
                    };
                },
                watch: {
                    selectValue(value) {
                        this.countryCode = value.country_call_code;
                        this.inputSearch = value.country_call_code;
                        if (this.internalChange === false) {
                            this.isSearching = true;
                        }

                        this.internalChange = false;

                        this.setMatch();
                    },
                    options() {
                        if (this.selectValue) {
                            this.setMatch();
                        }
                    }
                },
                computed: {
                    matchingOptions() {
                        const inputSearch = this.inputSearch.toString().toLowerCase();
                        if (inputSearch.length > 0) {
                            return this.options.filter(option => {
                                const phoneCleaned = this.cleanQuery(option.phone);
                                const concatData = Object.values(option);
                                concatData.push(phoneCleaned);
                                const searchString = concatData.join('').toLowerCase();
                                return searchString.indexOf(inputSearch) > -1;
                            });
                        }

                        return this.options;
                    }
                },
                mounted() {
                    document.body.addEventListener('click', this.handleClickOut);
                },
                destroyed() {
                    document.body.removeEventListener("click", this.handleClickOut);
                },
                methods: {
                    handleClickOut(event) {
                        const insideInputBox = this.$el.contains(event.target);
                        const insideOptionBox = this.$refs.optionsBox.contains(event.target);
                        
                        if (insideInputBox === false && insideOptionBox === false) {
                            this.isSearching = false;
                        }
                    },
                    cleanQuery(text) {
                        let result = text.toLocaleLowerCase().trim();
                        result = result.replaceAll(/[\+-]/ig, "");
                        return result;
                    },
                    handleKeyPress(event) {
                        const charCode = event.keyCode;
                        const charStr = String.fromCharCode(charCode);

                        const isValidChar = /[\d\-\+]/.test(charStr);
                        
                        if (isValidChar === false) {
                            event.preventDefault();
                        }
                    },
                    handleInputFocus() {
                        this.isSearching = true;
                    },
                    handleInputBlur(event) {
                        const optionsBox = this.$refs.optionsBox;
                        const eventInsideOptionsbox = optionsBox.contains(event.relatedTarget);

                        if (eventInsideOptionsbox) {
                            return;
                        }

                        this.isSearching = false;
                    },
                    handleInputEnter() {
                        let option;

                        if (this.pointer > -1) {
                            option = this.matchingOptions[this.pointer];
                        } else {
                            option = this.options.find(option => {
                                const phone = this.cleanQuery(option.phone);
                                const value = this.cleanQuery(this.selectValue);
                                return phone === value;
                            });
                        }

                        if (option) {
                            this.pointer = -1;
                            this.setSelected(option);
                        }
                    },
                    setSelectValue(value, prefix) {
                        if (this.selectValue !== value) {
                            this.internalChange = true;
                            this.$emit("input", {"country_call_code": value, "country_prefix": prefix});
                        }
                    },
                    setSearching() {
                        this.isSearching = true;
                        this.$emit('search');
                    },
                    setSelected(option) {
                        const phone = this.cleanQuery(option.phone);

                        this.isSearching = false;
                        this.setSelectValue(phone, option.code2);
                        this.$emit('select', option);
                    },
                    selectOption(event, option) {
                        event.stopPropagation();
                        this.setSelected(option);
                    },
                    movePointerUp() {
                        if (this.pointer > 0) {
                          this.pointer--;
                        }
                    },
                    movePointerDown(){
                        this.setSearching();

                        if (!this.matchingOptions) {
                            return;
                        }

                        if (this.pointer >= this.matchingOptions.length - 1) {
                            return;
                        }

                        this.pointer++;
                    },
                    setPointerIndex(index) {
                        this.pointer = index;
                    },
                    findMatch(needle) {
                        return this.options.find(option => {
                            const phone = this.cleanQuery(option.phone);
                            const value = this.cleanQuery(needle.country_call_code); // jshint ignore:line
                            return phone === value;
                        });
                    },
                    setMatch() {
                        const match = this.findMatch(this.selectValue);

                        if (match) {
                            this.prefix = match.code2;
                        } else {
                            this.prefix = "";
                        }
                    }
                }
            });

            return component;
        }
    });
});

aztech.use(function (pkg) {
    'use strict';
    pkg.factoryManager.get('app').create({
        name: 'dial-phone-field-bind',
        version: '0.0.1',
        dependencies: [
            'mod.vue',
            'app.dial-field'
        ],
        setup: function (__shared) {
            return __shared;
        },
        init: function (data, __shared) {
            const Vue = __shared.dependencies['mod.vue'];
            const DialField = __shared.dependencies['app.dial-field'];

            const component = Vue.component('az-dial-phone-field-bind', {
                template: `<div class="az-dial-phone-field-bind" :class="{ block }">
    <az-dial-field v-model="selfDial" :options="options" :error="error" ref="dial" />
    <az-phone-field v-model="selfPhone" :error="error" ref="phone" :block="block" />
</div>`,
                components: {
                    AzDialField: new DialField({})
                },
                props: {
                    dial: { type: Object, default(){return {};}},
                    phone: { type: String, default: "" },
                    error: Boolean,
                    block: Boolean,
                    required: Boolean
                },
                data: function() {
                    return {
                        options: [],
                        selfDial: this.dial,
                        selfPhone: this.phone,
                        internalChange: false
                    };
                },
                watch: {
                    selfDial(newValue) {
                        this.$emit('change-dial', newValue);
                    },
                    selfPhone(newValue) {
                        this.$emit('change-phone', newValue);
                    }
                },
                created() {
                    this.selfDial = this.dial;
                    this.selfPhone = this.phone;

                    this.fetchPhoneDials();
                },
                methods: {
                    validate() {
                        let validations = [];
                        const dialMatch = this.$refs.dial.findMatch(this.selfDial);

                        if (this.required && dialMatch === undefined) {
                            validations.push("Dial field is required");
                        }
                        
                        if (this.required && this.selfPhone.trim() === "") {
                            validations.push("Phone field is required");
                        }

                        return validations;
                    },
                    fetchPhoneDials() {
                        var data = {
                            body: {
                                'query': `{
                                    allCountries {
                                        code2
                                        code3
                                        phone
                                        name
                                    }
                                }`
                            },
                            url: `https://stage-cities.azion.com/graphql/`,
                        };
    
                        this.requestApi(data, response => {
                            const countries = response.data.allCountries;
                            const countriesWithDial = countries.filter(country => country.phone.trim() !== "");
                            
                            let options = countriesWithDial.map(country => {
                                let phones = country.phone.replaceAll(/\sand/ig, ",");
                                phones = phones.replaceAll(/\s/ig, "").split(",");

                                const countriesSeparated = phones.map(phone => {
                                    const copied = Object.assign({}, country);
                                    return Object.assign({}, copied, { phone });
                                });

                                return countriesSeparated;
                            });

                            options = options.flat();

                            this.options = options;
                        });
                    },
                    requestApi(data, callback) {
                        fetch(data.url, {
                            method: !data.method ? 'POST' : data.method,
                            crossdomain: true,
                            headers: {
                                'Content-Type': 'application/json',
                                'Accept': 'application/json; version=1'
                            },
                            body: JSON.stringify(data.body)
                        })
                        .then(response => response.json())
                        .then(data => callback(data))
                        .catch(error => callback(error));
                    }
                }
            });

            return component;
        }
    });
});
aztech.use(function (pkg) {
    'use strict';
    pkg.factoryManager.get('app').create({
        name: 'phone-field',
        version: '0.0.1',
        dependencies: ['mod.vue'],
        setup: function (__shared) {
            return __shared;
        },
        init: function (data, __shared) {
            const Vue = __shared.dependencies['mod.vue'];

            const component = Vue.component('az-phone-field', {
                template: `<div class="az-phone-field" :class="{ block, error }">
    <input
        type="text"
        :name="name"
        class="az-phone-field--input"
        maxlength="20" 
        @keypress="handleKeyPress"
        v-bind:value="phone"
        v-on:input="$emit('input', $event.target.value)" 
    />
</div>`,
                model: {
                    prop: 'phone',
                    event: 'input'
                },
                props: {
                    phone: String,
                    name: {
                        type: String,
                        default: "phone"
                    },
                    block: Boolean,
                    error: Boolean,
                },
                methods: {
                    handleKeyPress(event) {
                        const charCode = event.keyCode;
                        const charStr = String.fromCharCode(charCode);

                        const isValidChar = /\d/.test(charStr);
                        
                        if (isValidChar === false) {
                            event.preventDefault();
                        }
                    }
                }
            });

            return component;
        }
    });
});
aztech.use(function (pkg) {


    'use strict';


    pkg.factoryManager.get('app').create({
        name: 'field',
        version: '0.0.1',
        dependencies: [
            'mod.vue',
            'mod.hsimp'
        ],
        setup: function (__shared) {
            return __shared;
        },
        init: function (data, __shared) {
            if (data) {
                data = {};
            }

            var field = {};
            var PUBLIC = this;

            var Vue = __shared.dependencies['mod.vue'];

            PUBLIC.hsimp = __shared.dependencies['mod.hsimp'];

            field.component = Vue.component('az-field', {
                props: [
                    'type',
                    'name',
                    'default',
                    'info',
                    'regex',
                    'label',
                    'classes',
                    'required',
                    'validate',
                    'disabled',
                    'focus',
                    'props',
                    'placeholder'
                ],
                data: function () {
                    return {
                        value: null,
                        showPassword: false,
                        showPasswordInfo: false,
                        hsimp: PUBLIC.hsimp,
                        properties: {},
                        validator: this.getValidator(),
                        extras: {},
                        field: {
                            readonly: false,
                        }
                    };
                },
                model: {
                    prop: 'value',
                    event: 'change'
                },
                computed: {
                    valid: function() {
                        if (!this.required) {
                            return true;
                        } else {
                            return this.value ? this.validator.test(this.value) : null;
                        }
                    },
                    isEmpty: function() {
                        return this.validate ? !this.value : null;
                    },
                    invalid: function() {
                        return !this.isEmpty && this.valid === false;
                    },
                    getType: function() {
                        let type;

                        switch (this.type) {
                            case 'password':
                                type = this.showPassword ? 'text' : 'password';
                                break;
                            case 'email':
                                type = 'text';
                                break;
                            default:
                                type = this.type;
                                break;
                        }
                        return type;
                    },
                    getDisabledClass: function() {
                        return this.disabled ? "disabled" : "";
                    },
                },
                created: function() {
                    if (["text", "password", "textarea", "email"].includes(this.type) && this.default) {
                        this.value = this.default;
                        this.emitField();
                    }
                },
                mounted: function () {
                    this.setProperties();
                    this.configurationField();
                },
                methods: {
                    getValidator: function () {
                        var validator = this.regex;

                        switch (this.type) {
                            case 'email':
                                validator = /\S+@\S+\.\S+$/;
                                break;
                            case 'checkbox':
                                validator = /^(true)$/;
                                break;
                            case 'password':
                                if (!validator) {
                                    validator = {
                                        test: this.passwordValidator,
                                    };
                                }
                                break;
                        }
                        if (!validator) {
                            validator = new RegExp();
                        }

                        return validator;
                    },
                    setProperties: function () {
                        const passwordLevels = {
                            good: {
                                class: 'strong',
                                label: "Strong password"
                            },
                            bad: {
                                class: 'weak',
                                label: "Weak password"
                            },
                            ok: {
                                class: 'fair',
                                label: "Fair password"
                            }
                        };
                        if (this.type === 'password') {
                            this.properties = passwordLevels;
                        }
                    },
                    passwordValidator: function (value) {
                        var level = value ? this.hsimp(value).getSecurityLevel() : null;
                        
                        // Weak and Fair password show info
                        this.showPasswordInfo = level === "bad" || level === "ok";

                        if (level) {
                            this.extras.password = this.properties[level];
                            return level !== 'bad';
                        }
                        return null;
                    },
                    emitField: function () {
                        this.$emit('change', {
                            value: this.value,
                            valid: this.valid,
                        });
                    },
                    showText: function () {
                        this.showPassword = !this.showPassword;
                    },
                    configurationField: function() {
                        if(!this.props) {
                            return false;
                        }

                        this.field.readonly = this.props.readonly ? this.props.readonly : false;
                    }
                },
                watch: {
                    default: function(value) {
                        if ((this.type === "text" || this.type === "password" || this.type === "textarea") && value) {
                            this.value = value;
                            this.emitField();
                        }
                    }
                },
                template: `<div class="az-group" :required="required" v-if="type === 'password'">
    <div class="az-label" :for="this.name" :class="invalid || isEmpty ? 'error': ''">
        <div class="label-fld">
            <label class="name" v-if="label">{{ label }}:</label>
            <label class="name" v-else>{{ name }}:</label>

            <az-helper v-if="info">
                <p>{{ info }}</p>
            </az-helper>
        </div>

    </div>

    <div class="input password">
        <input
            type="password"
            :name="name"
            :type="getType"
            v-model="value"
            @input='emitField'
            :readonly="field.readonly"
        >

        <img src="https://aztechjs.azion.com/app-icons-aztech/_img/base/Visibility_Icon.svg" width="22" height="22" @click="showText" v-if="getType === 'text'">
        <img src="https://aztechjs.azion.com/app-icons-aztech/_img/base/Visibility_Close_Icon.svg" width="22" height="22" @click="showText" v-else>
    </span>
    </div>

    <div v-if="value && extras.password" class="password-strength" :class="extras.password.class">{{ extras.password.label }}</div>
    <div class="password-info" v-if="showPasswordInfo">
        <div class="password-info--icon">
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M6 10.9a4.9 4.9 0 100-9.8 4.9 4.9 0 000 9.8zM6 12A6 6 0 106 0a6 6 0 000 12z" fill="#646464"/><path d="M6.625 9H5.492V4.773h1.133V9zm-1.2-5.32a.56.56 0 01.169-.418c.114-.11.27-.164.465-.164a.64.64 0 01.46.164c.115.11.172.248.172.418a.551.551 0 01-.175.422.634.634 0 01-.457.164.648.648 0 01-.461-.164.557.557 0 01-.172-.422z" fill="#646464"/></svg>
        </div>
        <div class="password-info--text">
            For a strong password, enter more characters or change the existing ones, mixing letters, numbers and symbols.
        </div>
    </div>
    <div v-if="isEmpty" class="error-msg">This field is required</div>
</div>

<div class="az-checkbox" :required="required" :disabled="disabled" v-else-if="type === 'checkbox'">
    <label class="input checkbox" :for="'checkbox-'+name">
        <input type="checkbox" :id="'checkbox-'+name" name="name" v-model="value" @change='emitField'>
        <span />
    </label>

    <div class="checkbox-info" :class="getDisabledClass">
        {{info}}
        <slot></slot>
    </div>
</div>

<div class="az-group" :required="required" v-else-if="type === 'textarea'">
    <div class="az-label" :for="this.name" :class="invalid || isEmpty ? 'error': ''">
        <label class="name" :for="name" v-if="label">{{ label }}:</label>
        <label class="name" :for="name" v-else>{{ name }}:</label>

        <az-helper v-if="info">
            <p>{{ info }}</p>
        </az-helper>
    </div>

    <textarea :name="name" v-model="value" @input='emitField' v-focus="focus"></textarea>
    <div v-if="isEmpty" class="error-msg">This field is required</div>
    <div v-if="invalid" class="error-msg">Invalid {{this.name}}</div>
</div>

<div class="az-group" :required="required" v-else>
    <div v-if="name || label" class="az-label" :for="this.name" :class="invalid || isEmpty ? 'error': ''">
        <label class="name" :for="name" v-if="label">{{ label }}:</label>
        <label class="name" :for="name" v-else>{{ name }}:</label>

        <az-helper v-if="info">
            <p>{{ info }}</p>
        </az-helper>
    </div>
    <div v-else class="az-label without-label" :class="invalid || isEmpty ? 'error': ''">
    </div>
    <input
        :type="getType" :name="name" :placeholder="placeholder" class="input text"
        :readonly="field.readonly" v-model="value" @input='emitField' v-focus="focus"
    >
    <div v-if="isEmpty" class="error-msg">This field is required</div>
    <div v-if="invalid" class="error-msg">Invalid {{this.name}}</div>
</div>`
            });

            return field;
        },
    });
});

aztech.use(function (pkg) {
    'use strict';
    pkg.factoryManager.get('app').create({
        name: 'field-messages',
        version: '0.0.1',
        dependencies: [
            'mod.vue',
        ],
        setup: function (__shared) {
            return __shared;
        },
        init: function (data, __shared) {
            const Vue = __shared.dependencies['mod.vue'];

            const component = Vue.component('az-field-messages', {
                props: {
                    messages: {
                        type: Array,
                        default: function() {
                            return [];
                        }
                    }
                },
                template: `
                    <div class="az-field-messages">
                        <div 
                            class="az-field-messages--error" 
                            v-for="(message, index) in messages" 
                            :key="index"
                        >
                            {{ message }}
                        </div>
                    </div>
                `
            });

            return component;
        }
    });
});
aztech.use(function (pkg) {


    'use strict';


    pkg.factoryManager.get('app').create({
        name: 'alert',
        version: '0.0.1',
        dependencies: [
            'mod.vue'
        ],
        setup: function (__shared) {
            return __shared;
        },
        init: function (data, __shared) {
            if (data) {
                data = {};
            }

            var alert = {};

            var Vue = __shared.dependencies['mod.vue'];

            alert.component = Vue.component('az-alert', {
                props: [
                    'name',
                    'type',
                    'isHtml',
                    'message'
                ],
                data: function () {
                    return {
                        classes: {
                            icons: {
                                main: {
                                    success: 'icon-check-fullfill',
                                    error: 'icon-error-white',
                                    warning: 'icon-warning'
                                },
                                close: {
                                    error: 'icon-close-hot',
                                    success: 'icon-close-success',
                                    warning: 'icon-close-warning'
                                }
                            },
                            main: `alert-${this.type}`
                        }
                    };
                },
                computed: {
                    iconMain: function () {
                        return this.classes.icons.main[this.type];
                    },
                    iconClose: function () {
                        return this.classes.icons.close[this.type];
                    }
                },
                methods: {
                    hide: function () {
                        this.$emit('dropAlert', this.name);
                    }
                },
                template: `<div class="alert show" :class="classes.main">
    <div class="wrapper">
        <div class="type">
            <span class="icon icon-24" :class="iconMain"></span>
        </div>
        <div v-if="!isHtml" class="messages">{{ message }}</div>
        <div v-else class="messages" v-html="message"></div>
        <div class="icon icon-12" :class="iconClose" @click="hide"></div>
    </div>
</div>
`,
            });

            alert.group = Vue.component('alert-group', {
                props: {
                    alertList: {
                        type: Array,
                        default: function() {
                            return [];
                        }
                    },
                    limit: {
                        type: Number,
                        default: 0
                    }
                },
                template: `<div class="alerts">
  <transition-group name="alert" tag="div">
    <div v-for="alert in alertList" :key="alert.name">
        <az-alert :message="alert.message" :name="alert.name" :type="alert.type" :isHtml="alert.isHtml" @dropAlert="dropAlert"/>
    </div>
  </transition-group>
</div>
`,
                methods: {
                    dropAlert: function (alertName) {
                        this.$emit('drop', alertName);
                    },
                },
                watch: {
                    alertList: function(alerts) {
                        if (!alerts || this.limit <= 0 || alerts.length <= this.limit) {
                            return;
                        }
                        var overflow = alerts.length - this.limit;
                        [...Array(overflow)].forEach(() => {
                            this.dropAlert(alerts[0].name);
                        });
                    }
                }
            });

            alert.alertMixin = {
                data: function () {
                    return {
                        alerts: [],
                    };
                },
                methods: {
                    dropAlert: function (alertName) {
                        this.alerts = this.alerts.filter(function (alert) {
                            return alert.name !== alertName;
                        });
                    },
                    pushAlert: function (name, message, type, isHtml) {
                        if (!name) {
                            let randID = Math.random().toString(16).substr(2, 10);
                            name = `alert-${type}-${randID}`;
                        }
                        this.alerts.push({
                            name: name,
                            type: type,
                            message: message,
                            isHtml: isHtml ? isHtml : false
                        });
                    }
                }
            };

            return alert;
        },
    });
});

aztech.use(function (pkg) {


    'use strict';


    pkg.factoryManager.get('app').create({
        name: 'switch',
        version: '0.0.1',
        dependencies: [
            'mod.vue',
        ],
        setup: function (__shared) {
            return __shared;
        },
        init: function (data, __shared) {
            var Vue = __shared.dependencies["mod.vue"];
            var switchField = Vue.component("az-switch", {
                template: `<div class="az-switch">
    <label>
        {{label}}
    </label>
    <span :class="getClasses" @click="emitInvert"></span>
</div>`,
                props: [
                    'name',
                    'label',
                    'active',
                    'disabled',
                ],
                computed: {
                    getClasses: function() {
                        let classes = [];
                        if (this.active) {
                            classes.push("checked");
                        }
                        if (this.disabled) {
                            classes.push("disabled");
                        }
                        return classes.join(" ");
                    },
                },
                methods: {
                    emitInvert: function() {
                        if (!this.disabled) {
                            this.$emit('invert', this.name);
                        }
                    }
                }
            });
            return switchField;
        },
    });
});

aztech.use(function (pkg) {


    'use strict';


    pkg.factoryManager.get('app').create({
        name: 'tag-group',
        version: '0.0.1',
        dependencies: [
            'mod.vue',
        ],
        setup: function (__shared) {
            return __shared;
        },
        init: function (data, __shared) {
            var Vue = __shared.dependencies["mod.vue"];
            var tagGroup = Vue.component("az-tag-group", {
                template: `<div class="az-tag-group">
    <div class="input-area" @mousedown.prevent="setInputFocus">
        <div v-for="tag of tags" class="floating-tag">
            <p>{{ tag.name }}</p>
            <span class="delete-sign" @click="deleteTag(tag.id)">+</span>
        </div>
        <div class="tag-input">
            <input type="text"
                   ref="tagInputField"
                   v-model="inputText"
                   @keyup="setShowOptions(true)"
                   @keyup.enter="addTagFromEnter()"
                   @click="setShowOptions(true)"
                   @focus="setShowOptions(true)"
                   @blur="setShowOptions(false)"
            >
        </div>
    </div>
    <div v-show="showOptions" class="options-container">
        <option v-for="option of optionsShown" @mousedown.prevent="addTagFromClick(option.id, option.name)">{{ option.name }}</option>
    </div>
</div>`,
                props: [
                    'tags',
                    'options'
                ],
                data: function() {
                    return {
                        showOptions: false,
                        inputText: "",
                        newAddable: false,
                    };
                },
                methods: {
                    deleteTag: function(tagID) {
                        this.$emit("deleteTag", tagID);
                    },
                    addTagFromEnter: function() {
                        // Check if the input is not empty, and if it isn't the same as a currently existing tag name
                        if (this.inputText !== "" && !this.currentTagNames.includes(this.inputText)) {
                            let found = false;
                            for (let option of this.optionsShown) {
                                // If the input is the same as an already existing option name, create a tag from the said option
                                if (option.name === this.inputText) {
                                    this.$emit("attachTag", option.id, option.name);
                                    found = true;
                                    break;
                                }
                            }
                            // If there isn't an option with a name equals to the input, create a new tag from the input
                            if (!found) {
                                this.$emit("createTag", this.inputText);
                            }
                        }
                        this.setShowOptions(false);
                        this.inputText = "";
                    },
                    addTagFromClick: function(tagID, tagName) {
                        // If the selected option matches the "(add new)" option, create a new tag from the input.
                        // Otherwise, create a tag from the selected option 
                        if (!tagID && tagName === this.createNewTagOption) {
                            this.$emit("createTag", this.inputText);
                        } else {
                            if (!this.currentTagNames.includes(this.inputText)) {
                                this.$emit("attachTag", tagID, tagName);
                            }
                        }
                        this.setShowOptions(false);
                        this.inputText = "";
                    },
                    setShowOptions: function(show) {
                        this.showOptions = show;
                    },
                    setInputFocus: function() {
                        this.$refs.tagInputField.focus();
                        this.setShowOptions(true);
                    }
                },
                computed: {
                    currentTagNames: function() {
                        return this.tags.map(({ name }) => name);
                    },
                    currentOptionNames: function() {
                        return this.optionsShown.map(({ name }) => name);
                    },
                    optionsShown: function() {
                        this.newAddable = false;
                        var tempArr = [];
                        // If the input is empty, it means that all of the options must be shown
                        if (this.inputText === "") {
                            // Deep copy the options that doesn't already exists as a tag
                            for (let option of this.options) {
                                if (!this.tags.includes(option)) {
                                    tempArr.push(option);
                                }
                            }
                        // If the input is not empty...
                        } else {
                            let that = this;
                            // List options that matches to the input, and that doesn't exists as a tag
                            tempArr = this.options.filter((option) => {
                                return option.name.includes(that.inputText) && !that.tags.includes(option);
                            });
                            // If the input is not exacly the same as option or tag name, add a option to create a new tag with the input
                            if (!tempArr.map(({ name }) => name).includes(this.inputText) && !this.currentTagNames.includes(this.inputText)) {
                                this.newAddable = true;
                                tempArr.push({
                                    "id": null,
                                    "name": this.createNewTagOption
                                });
                            }
                        }
                        return tempArr;
                    },
                    createNewTagOption: function() {
                        return `${this.inputText} (add new)`;
                    }
                }
            });
            return tagGroup;
        },
    });
});

aztech.use(function (pkg) {
    'use strict';


    pkg.factoryManager.get('app').create({
        name: 'card',
        version: '0.0.1',
        dependencies: [
            'mod.vue',
        ],
        setup: function (__shared) {
            return __shared;
        },
        init: function (data, __shared) {
            var card = {};

            var Vue = __shared.dependencies['mod.vue'];

            card.component = Vue.component('az-card', {
                template: `<div class="az-card">
    <slot></slot>
</div>`,
            });

            return card;
        },
    });
});

aztech.use(function(pkg) {


    'use strict';


    pkg.factoryManager.get('app').create({
        name: 'name-field',
        version: '0.0.1',
        dependencies: [
            'mod.vue'
        ],
        setup: function (__shared) {
            return __shared;
        },
        init: function(data, __shared) {
            if (data) {
                data = {};
            }

            var nameField = {};

            var Vue = __shared.dependencies['mod.vue'];

            nameField.component = Vue.component('az-name-field', {
                template: `<div class="az-name-field">
    <div class="name-field">
        <input type="text"
               v-model="currentInput" 
               :placeholder="placeholder" 
               class="edit-field" 
               :class="inputClasses" 
               @focus="focus" 
               @blur="blur"
               @mouseenter="hovered = true"
               @mouseleave="hovered = false"
               ref="inputField">
        <span class="icon" :class="iconClasses"></span>
        <span v-if="required && !isTitle" class="mandatory-icon">*</span>
    </div>
    <div v-if="isEmpty" class="error-msg">This field is required</div>
    <div v-else-if="isInvalid" class="error-msg">Invalid {{ name }}</div>
</div>`,
                props: [
                    'input',
                    'name',
                    'placeholder',
                    'isTitle',
                    'required',
                    'validate',
                    'focused',
                    'regex'
                ],
                data: function () {
                    return {
                        justLoaded: true,
                        currentInput: this.input,
                        lastInput: this.input,
                        hovered: false,
                        inputClasses: {
                            focused: false,
                            title: this.isTitle,
                            text: !this.isTitle
                        },
                    };
                },
                methods: {
                    focus: function () {
                        this.inputClasses.focused = true;
                        
                        // This is a mechanism to avoid the event to be emitted right after the component
                        // was created with the focused flag set
                        if (this.justLoaded && this.focused) {
                            this.justLoaded = false;
                            return;
                        }
                        
                        this.$emit("focusStateChanged", true);
                    },
                    blur: function() {
                        this.inputClasses.focused = false;
                        this.$emit("focusStateChanged", false);
                        if (this.currentInput !== this.lastInput) {
                            this.lastInput = this.currentInput ;
                            this.$emit("fieldChanged", this.currentInput, !this.isInvalid);
                        }
                    },
                    setAutoFocus: function() {
                        this.$refs.inputField.focus();
                    }
                },
                computed: {
                    isEmpty: function() {
                        return this.required && this.validate && !this.currentInput;
                    },

                    isInvalid: function() {
                        if (this.isEmpty) {
                            return true;
                        }
                        if (this.regex && this.currentInput !== "") {
                            this.regex.lastIndex = 0;
                            return !this.regex.test(this.currentInput);
                        }
                        return false;
                    },

                    iconClasses: function() {
                        var classBuilder = {};
                        
                        if (this.isTitle) {
                            classBuilder = { "icon-title": true, "icon-18": true, "icon-pencil-2": true };
                        } else {
                            classBuilder = { "icon-title": false, "icon-14": true, "icon-pencil-2-silver": true };
                        }
                        
                        return this.hovered ? classBuilder : Object.assign(classBuilder, { "icon-hidden": true });
                    }
                },
                watch: {
                    input: function() {
                        this.currentInput = this.input;
                        this.lastInput = this.input;
                    },

                    isInvalid: function(value) {
                        if (value) {
                            this.inputClasses.invalid = true;
                        } else {
                            this.inputClasses.invalid = false;
                        }
                    },

                    focused: function(value) {
                        if (value) {
                            this.setAutoFocus();
                        }
                    }
                },
                mounted: function() {
                    if (this.focused) {
                        this.setAutoFocus();
                    }
                }
            });
            return nameField;
        }
    });
});
aztech.use(function(pkg) {


    'use strict';
    
    
    pkg.factoryManager.get('app').create({
        name: 'subfooter',
        version: '0.0.1',
        dependencies: [
            'mod.vue'
        ],
        setup: function (__shared) {
            return __shared;
        },
        init: function(data, __shared) {
            if(!data) {
                data = {};
            }

            var subfooter = {};

            var Vue = __shared.dependencies['mod.vue'];

            subfooter.component = Vue.component('az-subfooter', {
                template: `<div class="az-subfooter">
    <div class="content">
        <div class="subfooter-content">
            <div v-if="showCheckbox" class="subfooter-checkbox">
                <az-switch :label="checkboxLabel" :active="checkboxActive" @invert="checkboxToggled"></az-switch>
            </div>
            <p v-if="showLink" class="subfooter-link-btn" @click="linkClicked">{{ linkText }}</p>
            <button input="button" class="btn" @click="buttonClicked">{{ buttonText }}</button>
        </div>
    </div>
</div>`,
                props: [
                    'buttonText',
                    'linkText',
                    'checkboxLabel',
                    'checkboxActive'
                ],
                data: function() {
                    return {
                        bntColorClass: ""  
                    };
                },
                methods: {
                    buttonClicked: function() {
                        this.$emit("buttonClicked");
                    },
                    linkClicked: function() {
                        this.$emit("linkClicked");
                    },
                    checkboxToggled: function() {
                        this.$emit("checkboxToggled");
                    }
                },
                computed: {
                    showLink: function() {
                        return this.linkText && this.linkText !== "";
                    },
                    showCheckbox: function() {
                        return this.checkboxLabel && this.checkboxLabel !== "";
                    }
                }
            });
            return subfooter;
        }
    });
});
aztech.use(function(pkg) {


    'use strict';


    pkg.factoryManager.get('app').create({
        name: 'pagination',
        version: '0.0.1',
        dependencies: [
            'mod.vue'
        ],
        setup: function (__shared) {
            return __shared;
        },
        init: function(data, __shared) {
            if (data) {
                data = {};
            }

            var pagination = {};

            var Vue = __shared.dependencies['mod.vue'];

            pagination.component = Vue.component('az-pagination', {
                template: `<div class="az-pagination">
    <button v-for="page of pagesList" @click="pageSelected(page)" class="btn btn-pagination" :class="page.buttonClass">{{ page.index }}</button>
</div>`,
                props: [
                    'numPages',
                    'currentPage'
                ],
                data: function () {
                    return {};
                },
                methods: {
                    pageSelected: function(page) {
                        if (page.index !== this.currentPage) {
                            this.$emit("pageSelected", page.index);
                        }
                    },
                },
                computed: {
                    pagesList: function() {

                        if (!this.numPages || this.numPages < this.currentPage) {
                            return [];
                        }

                        // Build the array with the pages indexes
                        var pagesIndexes = [];
                        var totalPages = [...Array(this.numPages).keys()].map(x => ++x);
                        var extremeClasses = {
                            left: "extreme",
                            right: "extreme",
                        };
                        if (totalPages.length <= 5) { // [1, 2, 3, 4, 5]
                            pagesIndexes = totalPages;
                            extremeClasses = {
                                left: "available",
                                right: "available",
                            };
                        } else {
                            pagesIndexes = [1];
                            if (this.currentPage <= 3) { // [1, 2, 3, 4, 10]
                                extremeClasses.left = "available";
                                pagesIndexes = pagesIndexes.concat([2, 3, 4]);
                            } else if (this.currentPage >= this.numPages - 2) { // [1, 7, 8, 9, 10]
                                extremeClasses.right = "available";
                                pagesIndexes = pagesIndexes.concat([this.numPages - 3, this.numPages - 2, this.numPages - 1]);
                            } else { // [1, 5, 6, 7, 10]
                                pagesIndexes = pagesIndexes.concat([this.currentPage - 1, this.currentPage, this.currentPage + 1]);
                            }
                            pagesIndexes.push(this.numPages);
                        }

                        // Append the right button class to each page index
                        var pages = [];
                        for (let index of pagesIndexes) {
                            var page = {index: index};
                            if (index === this.currentPage) {
                                page.buttonClass = "selected";
                            } else if (index === 1) {
                                page.buttonClass = extremeClasses.left;
                            } else if (index === this.numPages) {
                                page.buttonClass = extremeClasses.right;
                            } else {
                                page.buttonClass = "available";
                            }
                            pages.push(page);
                        }

                        return pages;
                    },
                }
            });
            return pagination;
        }
    });
});
aztech.use(function(pkg) {


    'use strict';


    pkg.factoryManager.get('app').create({
        name: 'search',
        version: '0.0.1',
        dependencies: [
            'mod.vue'
        ],
        setup: function (__shared) {
            return __shared;
        },
        init: function(data, __shared) {
            if (data) {
                data = {};
            }

            var search = {};

            var Vue = __shared.dependencies['mod.vue'];

            search.component = Vue.component('az-search', {
                template: `<div class="az-search">
    <label for="search-input">Search:</label>
    <input id="search-input" @keyup.enter="search" v-model="input" type="text" placeholder="Type to filter results...">
    <span></span>
</div>`,
                data: function () {
                    return {
                        input: '',
                    };
                },
                methods: {
                    search: function () {
                        this.$emit('search', this.input);
                    },
                }
            });
            return search;
        }
    });
});
aztech.use(function(pkg) {
    'use strict';
    pkg.factoryManager.get('app').create({
        name: 'confirm',
        version: '0.0.1',
        dependencies: [
            'mod.vue'
        ],
        setup: function (__shared) {
            return __shared;
        },
        init: function(data, __shared) {
            if(!data) {
                data = {};
            }

            var confirm = {};

            const Vue = __shared.dependencies['mod.vue'];

            confirm.component = Vue.component('az-confirm', {
                template: `<div class="az-confirm">
    <div class="confirmation-fade"></div>
    <div class="confirmation-modal">
        <p class="modal-title">{{ title }}</p>
        <p class="modal-description">{{ description }}</p>
        <input v-if="isConfirmable" v-model="confirmationTextInputted" type=text class="modal-text">
        <div class="modal-options">
            <p class="leave-text" @click="leaveClicked">{{ leaveText }}</p>
            <button input="button" class="btn apply-button" :disabled="!isApplyEnabled" @click="applyClicked">{{ applyText }}</button>
        </div>
    </div>
</div>`,
                data: function() {
                    return {
                        confirmationTextInputted: "",
                    };
                },
                props: {
                    title: {
                        type: String,
                        required: true
                    },
                    description: {
                        type: String,
                        required: true
                    },
                    confirmationText: {
                        type: String,
                        required: false,
                        default: null
                    },
                    leaveText: {
                        type: String,
                        required: true
                    },
                    applyText: {
                        type: String,
                        required: true
                    }
                },
                methods: {
                    leaveClicked: function() {
                        this.$emit("leaveClicked");
                    },
                    applyClicked: function() {
                        this.$emit("applyClicked");
                    }
                },
                computed: {
                    isConfirmable: function() {
                        return Boolean(this.confirmationText);
                    },
                    isApplyEnabled: function() {
                        if (this.isConfirmable) {
                            return this.confirmationTextInputted === this.confirmationText;
                        } else {
                            return true;
                        }
                    }
                }
            });
            return confirm;
        }
    });
});
aztech.use(function(pkg) {


    'use strict';


    pkg.factoryManager.get('app').create({
        name: 'helper',
        version: '0.0.1',
        dependencies: [
            'mod.vue'
        ],
        setup: function (__shared) {
            return __shared;
        },
        init: function(data, __shared) {
            if (data) {
                data = {};
            }

            var helper = {};

            var Vue = __shared.dependencies['mod.vue'];

            Vue.directive('click-out', {
                bind: function(el, binding, vnode) {
                    el.clickOutsideEvent = function(event) {
                        if (!(el == event.target || el.contains(event.target))) {
                            vnode.context[binding.expression](event);
                        }
                    };
                    document.body.addEventListener("click", el.clickOutsideEvent);
                    document.body.addEventListener("touchstart", el.clickOutsideEvent);
                },
                unbind: function(el) {
                    document.body.removeEventListener("click", el.clickOutsideEvent);
                    document.body.removeEventListener("touchstart", el.clickOutsideEvent);
                },
                stopProp(event) {
                    event.stopPropagation();
                }
            });

            helper.component = Vue.component('az-helper', {
                template: `<div class="az-helper">
    <div class="tooltip-icon-container" @mouseenter="setHovered(true)" @mouseleave="setHovered(false)" @click="handleClickIn" v-click-out="handleClickOut">
        <img v-if="tooltipFocused" :src="tooltipIcon.focused">
        <img v-else :src="tooltipIcon.normal">
    </div>
    <div v-show="showHelperText" class="helper-text" @click="handleClickOut">
        <span class="az-tooltip">
            <slot></slot>
        </span>
    </div>
</div>`,
                data: function () {
                    return {
                        hovered: false,
                        clicked: false,
                        tooltipIcon: {
                            focused: "https://aztechjs.azion.com/app-icons-aztech/_img/base/Tooltip_Icon.svg",
                            normal: "https://aztechjs.azion.com/app-icons-aztech/_img/base/silver_tooltip_icon.svg"
                        }
                    };
                },
                methods: {
                    handleClickIn: function() {
                        this.clicked = true;
                    },
                    handleClickOut: function() {
                        if (this.clicked) {
                            this.clicked = false;
                        }
                    },
                    setHovered: function(hovered) {
                        this.hovered = hovered;
                    }
                },
                computed: {
                    tooltipFocused: function() {
                        return this.hovered || this.clicked;
                    },
                    showHelperText: function() {
                        return this.clicked;
                    }
                }
            });
            return helper;
        }
    });
});
aztech.use(function (pkg) {
    'use strict';
    pkg.factoryManager.get('app').create({
        name: 'label',
        version: '0.0.1',
        dependencies: [
            'mod.vue',
            'app.helper'
        ],
        setup: function (__shared) {
            return __shared;
        },
        init: function (data, __shared) {
            const Vue = __shared.dependencies['mod.vue'];
            const Helper = __shared.dependencies['app.helper'];

            const component = Vue.component('az-label', {
                components: {
                    AzHelper: new Helper({}).component
                },
                props: {
                    title: String,
                    info: String,
                    error: Boolean,
                    required: Boolean
                },
                template: `
                    <div class="az-label" :for="title" :class="{ error }" :required="required">
                        <div class="label-fld">
                            <label class="name">{{ title }}:</label>

                            <az-helper v-if="info">
                                <p>{{ info }}</p>
                            </az-helper>
                        </div>
                    </div>
                `
            });

            return component;
        }
    });
});
aztech.use(function(pkg) {
    'use strict';
    pkg.factoryManager.get('app').create({
        name: 'select',
        version: '0.0.1',
        dependencies: [
            'mod.vue'
        ],
        setup: function(__shared) {
          return __shared;
        },
        init: function(data, __shared) {
            if (data) {
                data = {};
            }

            let Vue = __shared.dependencies['mod.vue'];

            var select = Vue.component('az-select', {
                template: `<div class="az-group" :required="required">
    <div class="az-select">
        <div class="select-area">
            <div class="az-label" :class="labelClass">
                <label class="name">{{ label }}:</label>
                <az-helper v-if="info">
                    <p>{{ info }}</p>
                </az-helper>
            </div>
            <div @click="toggleOptionsList" @mouseenter="setHovered(true)" @mouseleave="setHovered(false)">
                <input
                    readonly
                    :value="inputValue"
                    type="text"
                    :class="inputClass"
                    @blur="handleClickOut"
                >
                <span :class="caretClass"></span>
            </div>
        </div>
        <div v-if="optionsShowable" class="options-container">
            <div class="options" v-for="option of options" @mousedown.prevent="optionSelected(option)">{{ option.name }}</div>
        </div>
    </div>
    <div v-if="isEmpty" class="error-msg">This field is required</div>
</div>
`,
                props: {
                    label: {
                        type: String,
                        required: true
                    },
                    options: {
                        type: Array,
                        default: () => []
                    },
                    info: String,
                    defaultOption: Object,
                    required: Boolean,
                    showValidation: Boolean,
                    readonly: Boolean,
                    placeholder: String
                },
                data: function() {
                    return {
                        hovered: false,
                        showOptions: false,
                        selected: {
                            id: null,
                            name: ""
                        }
                    };
                },
                computed: {
                    inputValue: function() {
                        return this.selected.name || this.placeholder;
                    },
                    invalid: function() {
                        return this.required && this.showValidation && !this.selected.id;
                    },
                    isEmpty: function() {
                        return this.showValidation && this.required && !this.selected.id;
                    },
                    caretClass: function() {
                        var caretClass = "caret";
                        caretClass += this.optionsShowable ? " up" : "";
                        if (this.readonly) {
                            caretClass += " readonly";
                        }
                        else if (this.invalid) {
                            caretClass += " error";
                        } else if (!this.hovered && !this.showOptions) {
                            caretClass += " silver";
                        }
                        return caretClass;
                    },
                    inputClass: function() {
                        var inputClass = "";
                        if (this.readonly) {
                            inputClass = "readonly";
                        } else if (this.invalid) {
                            inputClass = "error";
                        }

                        return inputClass;
                    },
                    labelClass: function() {
                        var labelClass = "";
                        if (this.readonly) {
                            labelClass = "readonly";
                        } else if (this.invalid) {
                            labelClass = "error";
                        }
                        return labelClass;
                    },
                    optionsShowable: function() {
                        return this.showOptions && !this.readonly;
                    }
                },
                created: function() {
                    if (this.defaultOption) {
                        this.optionSelected(this.defaultOption);
                    }
                },
                methods: {
                    optionSelected: function(value) {
                        this.showOptions = false;
                        this.selected = value;
                        this.$emit('optionSelected', value);
                    },
                    setHovered: function(hovered) {
                        this.hovered = hovered;
                    },
                    handleClickOut: function() {
                        this.showOptions = false;
                    },
                    toggleOptionsList: function() {
                        this.showOptions = !this.showOptions;
                    }
                },
                watch: {
                    defaultOption: function(newOption) {
                        this.optionSelected(newOption);
                    },
                    options: function() {
                        if (this.selected.id !== null) {
                            this.optionSelected({id: null, name: ""});
                        }
                    }
                }
            });
            return select;
        }
    });
});

aztech.use(function (pkg) {
    'use strict';
    pkg.factoryManager.get('app').create({
        name: 'select-autocomplete',
        version: '0.0.1',
        dependencies: ['mod.vue'],
        setup: function (__shared) {
            return __shared;
        },
        init: function (data, __shared) {
            const Vue = __shared.dependencies['mod.vue'];
            
            const component = Vue.component('az-select-autocomplete', {
                template: `<div class="az-select-autocomplete" :class="{ 'is-searching': isSearching, 'is-selected': isSelected, block, error }">
    <div class="az-select-autocomplete--inputbox">
        <input 
            type="text"
            name="select"
            autocomplete="off"
            v-model="selectValue"
            @focus="handleInputFocus"
            @blur="handleBlur"
            @keydown.enter.prevent="handleInputEnter"
            @keyup.esc.stop="closeOut"
            @keyup.down="movePointerDown"
            @keyup.up="movePointerUp"
            class="az-select-autocomplete--input"
            ref="input"
            tabindex="0"
        />
        <div class="az-select-autocomplete--iconbox" @click="cleanSearch">
            <div v-if="!isSelected">
                <svg width="9" height="5" viewBox="0 0 9 5" fill="none" xmlns="http://www.w3.org/2000/svg" class="az-select-autocomplete--icon-arrow" aria-hidden="true">
                    <path d="M0.605575 0H8.39443C8.93326 0 9.20267 0.637415 8.82125 1.01097L4.92834 4.82656C4.69222 5.05781 4.30778 5.05781 4.07166 4.82656L0.178747 1.01097C-0.202673 0.637415 0.0667427 0 0.605575 0Z" fill="#646464"/>
                </svg>
            </div>
            <div v-else>
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" class="az-select-autocomplete--icon-close" aria-hidden="true" tabindex="0">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12 1.20857L10.7914 0L6 4.79143L1.20857 0L0 1.20857L4.79143 6L0 10.7914L1.20857 12L6 7.20857L10.7914 12L12 10.7914L7.20857 6L12 1.20857Z" fill="#AAAAAA"/>
                </svg>
            </div>
        </div>
    </div>
    <div class="az-select-autocomplete--optionsbox" ref="optionsBox">
        <div class="az-select-autocomplete--option disabled"
            tabindex="0"
            v-if="matchingOptions.length === 0"
            key="no-option">
            Nothing found
        </div>
        <div 
            class="az-select-autocomplete--option"
            tabindex="0"
            v-else
            v-for="(option, index) in matchingOptions"
            @click="(event) => selectOption(event, option)"
            @keyup.enter="(event) => selectOption(event, option)" 
            @blur="handleBlur"
            @focus="handleOptionFocus"
            :class="{active: pointer === index}"
            :key="index" 
        >
            {{ option.label }}
        </div>
    </div>
</div>
`,
                props: {
                    options: Array,
                    block: Boolean,
                    error: Boolean,
                },
                data: function() {
                    return {
                        isSelected: false,
                        isSearching: false,
                        internalChange: false,
                        selectValue: "",
                        pointer: -1
                    };
                },
                watch: {
                    options() {
                        this.cleanSearch();
                    },
                    selectValue() {
                        if (this.internalChange === false) {
                            this.isSelected = false;
                            this.isSearching = true;
                        }

                        this.internalChange = false;
                    },
                },
                computed: {
                    matchingOptions() {
                        if (this.selectValue) {
                            return this.options.filter(option => {
                                const label = option.label.toLocaleLowerCase().trim();
                                const value = this.selectValue.toLocaleLowerCase().trim();
                                return label.indexOf(value) > -1;
                            });
                        }

                        return this.options;
                    }
                },
                mounted() {
                    document.body.addEventListener('click', this.handleClickOut);
                },
                destroyed() {
                    document.body.removeEventListener("click", this.handleClickOut);
                },
                methods: {
                    handleClickOut(event) {
                        const insideInputBox = this.$el.contains(event.target);
                        const insideOptionBox = this.$refs.optionsBox.contains(event.target);
                        
                        if (insideInputBox === false && insideOptionBox === false) {
                            this.closeOut();
                        }
                    },
                    handleInputFocus() {
                        if (this.isSelected === false) {
                            this.isSearching = true;
                        }
                    },
                    handleOptionFocus() {
                        if (this.isSelected === false && this.isSearching === false) {
                            this.$refs.input.focus();
                        }
                    },
                    handleBlur(event) {
                        const optionsBox = this.$refs.optionsBox;
                        const eventInsideOptionsbox = optionsBox.contains(event.relatedTarget);

                        if (eventInsideOptionsbox) {
                            return;
                        }

                        this.closeOut();
                    },
                    handleInputEnter() {
                        let option;

                        if (this.pointer > -1) {
                            option = this.matchingOptions[this.pointer];
                        } else {
                            option = this.options.find(option => {
                                const label = option.label.toLocaleLowerCase().trim();
                                const value = this.selectValue.toLocaleLowerCase().trim();
                                return label === value;
                            });
                        }

                        if (option) {
                            this.pointer = -1;
                            this.setSelected(option);
                        }
                    },
                    setSelectValue(value) {
                        if (this.selectValue !== value) {
                            this.internalChange = true;
                            this.selectValue = value;
                        }
                    },
                    setSearching() {
                        this.isSelected = false;
                        this.isSearching = true;
                        this.$emit('search');
                    },
                    setSelected(option) {
                        this.isSelected = true;
                        this.isSearching = false;
                        this.setSelectValue(option.label);
                        this.$emit('select', option);
                    },
                    closeOut() {
                        this.isSearching = false;

                        if (this.isSelected === false) {
                            this.setSelectValue("");
                        }
                    },
                    selectOption(event, option) {
                        event.stopPropagation();
                        this.setSelected(option);
                    },
                    cleanSearch() {
                        if (this.isSelected) {
                            this.setSearching();
                            this.setSelectValue("");
                            this.$refs.input.focus();
                        }
                    },
                    movePointerUp() {
                        if (this.pointer > 0) {
                          this.pointer--;
                        }
                    },
                    movePointerDown(){
                        this.setSearching();
                        
                        if (!this.matchingOptions) {
                            return;
                        }

                        if (this.pointer >= this.matchingOptions.length - 1) {
                            return;
                        }

                        this.pointer++;
                    },
                    setPointerIndex(index) {
                        this.pointer = index;
                    }
                },
            });

            return component;
        },
    });
});

aztech.use(function (pkg) {
    'use strict';


    pkg.factoryManager.get('app').create({
        name: 'disclaimer',
        version: '0.0.1',
        dependencies: [
            'mod.vue',
        ],
        setup: function (__shared) {
            return __shared;
        },
        init: function (data, __shared) {
            var disclaimer = {};

            var Vue = __shared.dependencies['mod.vue'];

            disclaimer.component = Vue.component('az-disclaimer', {
                props: ["message"],
                template: `<div class="az-disclaimer">
    <p v-html="message"></p>
</div>
`,
            });

            return disclaimer;
        },
    });
});

aztech.use(function (pkg) {


    'use strict';


    pkg.factoryManager.get('app').create({
        name: 'header',
        version: '0.0.1',
        dependencies: [
            'mod.vue'
        ],
        setup: function (__shared) {
            return __shared;
        },
        init: function (data, __shared) {
            if (data) {
                data = {};
            }

            var header = {};

            var Vue = __shared.dependencies['mod.vue'];

            Vue.directive('click-out', {
                bind: function(el, binding, vnode) {
                    el.clickOutsideEvent = function(event) {
                        if (!(el == event.target || el.contains(event.target))) {
                            vnode.context[binding.expression](event);
                        }
                    };
                    document.body.addEventListener("click", el.clickOutsideEvent);
                    document.body.addEventListener("touchstart", el.clickOutsideEvent);
                },
                unbind: function(el) {
                    document.body.removeEventListener("click", el.clickOutsideEvent);
                    document.body.removeEventListener("touchstart", el.clickOutsideEvent);
                },
                stopProp(event) {
                    event.stopPropagation();
                }
            });

            var productLabelIsValid = function(label) {
                return ['beta', 'ia'].indexOf(label) !== -1;
            };

            var getProductLabelClass = function(label) {
                switch (label) {
                    case "beta":
                        return "beta-label";
                    case "ia":
                        return "internal-access-label";
                    default:
                        return "";
                }
            };

            header.common = Vue.component('az-header-common', {
                props: {
                    title: {
                        type: String,
                        required: true,
                    },
                    documentationLink: {
                        type: String,
                        required: false,
                    },
                    buttonText: {
                        type: String,
                        required: false,
                    },
                    buttonOptions: {
                        type: Array,
                        required: false,
                        default: function() {
                            return [];
                        }
                    },
                    buttonDisabled: {
                        type: Boolean,
                        required: false,
                        default: false,
                    },
                    productLabel: {
                        type: String,
                        required: false,
                        validator: function(value) {
                            return productLabelIsValid(value);
                        }
                    }
                },
                data: function () {
                    return {
                        showDropdownOptions: false
                    };
                },
                computed: {
                    showDocumentation: function() {
                        return Boolean(this.documentationLink);
                    },
                    showButton: function() {
                        return Boolean(this.buttonText);
                    },
                    buttonIsDropdown: function() {
                        return this.buttonOptions.length > 0;
                    },
                    caretClass: function() {
                        var caretClass = "caret";
                        caretClass += this.showDropdownOptions ? " up" : "";
                        return caretClass;
                    },
                    showingOptionsClass: function() {
                        return this.showDropdownOptions ? "showing-options" : "";
                    },
                    productLabelClass: function() {
                        return getProductLabelClass(this.productLabel);
                    }
                },
                methods: {
                    toggleDropdownOptions: function() {
                        if (!this.buttonDisabled) {
                            this.showDropdownOptions = !this.showDropdownOptions;
                        }
                    },
                    hideDropdownOptions: function() {
                        this.showDropdownOptions = false;
                    },
                    dropdownOptionSelected: function(option) {
                        this.hideDropdownOptions();
                        this.$emit("buttonOptionSelected", option);
                    },
                    buttonClicked: function() {
                        this.$emit("buttonClicked");
                    },
                },
                template: `<div class="az-header header-common">
    <div class="content header-content">
        <div class="header-text">
            <p class="header-title" :class="productLabelClass">{{ title }}</p>
        </div>
        <div v-if="showDocumentation" class="header-documentation">
            <a :href="documentationLink" target="_blank">Documentation</a>
            <span class="icon icon-12 icon-new-tab-gray"></span>
        </div>
        <div v-if="showButton" class="header-button">
            <div v-if="buttonIsDropdown" class="btn-dropdown" v-click-out="hideDropdownOptions">
                <div class="btn btn-container" :class="showingOptionsClass" :disabled="buttonDisabled" @click="toggleDropdownOptions">
                    <span class="btn-text">{{ buttonText }}</span>
                    <span :class="caretClass"></span>
                </div>
                <ul v-if="showDropdownOptions" class="options-container">
                    <li v-for="option of buttonOptions" @mousedown.prevent="dropdownOptionSelected(option)">{{ option.text }}</li>
                </ul>
            </div>
            <button v-else type="button" :disabled="buttonDisabled" class="btn" @click="buttonClicked">{{ buttonText }}</button>
        </div>
    </div>
</div>`,
            });

            header.form = Vue.component('az-header-form', {
                props: {
                    title: {
                        type: String,
                        required: true,
                    },
                    placeholder: {
                        type: String,
                        required: false,
                        default: "",
                    },
                    subtitle: {
                        type: String,
                        required: true,
                    },
                    productLabel: {
                        type: String,
                        required: false,
                        validator: function(value) {
                            return productLabelIsValid(value);
                        }
                    },
                },
                data: function () {
                    return {
                        inputFocused: false,
                        fieldRequiredEnabled: true,
                    };
                },
                computed: {
                    productLabelClass: function() {
                        return getProductLabelClass(this.productLabel);
                    }
                },
                methods: {
                    titleChanged: function(title, valid) {
                        this.$emit("titleChanged", title, valid);
                    },
                    subtitleClicked: function() {
                        this.$emit("subtitleClicked");
                    },
                    titleFocusStatusChanged: function(value) {
                        if (!value && !Boolean(this.title)) {
                            this.fieldRequiredEnabled = true;
                        }
                    }
                },
                template: `<div class="az-header header-form">
    <div class="content header-content">
        <div class="header-text">
            <p class="header-subtitle" :class="productLabelClass" @click="subtitleClicked">{{ subtitle }}</p>
            <az-name-field
                :input="title"
                :placeholder="placeholder"
                :isTitle="true"
                :required="fieldRequiredEnabled"
                :validate="true"
                :focused="inputFocused"
                @fieldChanged="titleChanged"
                @focusStateChanged="titleFocusStatusChanged"
                >
            </az-name-field>
        </div>
    </div>
</div>`,
                created: function() {
                    // When the component is created, if the title property is an empty string,
                    // it should not show the validation; the validation message will be shown 
                    // when the user un-focus the field
                    if (!Boolean(this.title)) {
                        this.inputFocused = false;
                        this.fieldRequiredEnabled = false;
                    }
                }
            });

            return header;
        },
    });
});

aztech.use(function (pkg) {
    'use strict';
    pkg.factoryManager.get('app').create({
        name: 'field-group',
        version: '0.0.1',
        dependencies: [
            'mod.vue',
            'app.label',
            'app.field-messages'
        ],
        setup: function (__shared) {
            return __shared;
        },
        init: function (data, __shared) {
            const Vue = __shared.dependencies['mod.vue'];
            const Label = __shared.dependencies['app.label'];
            const FieldMessages = __shared.dependencies['app.field-messages'];

            const component = Vue.component('az-field-group', {
                components: {
                    Label: new Label({}),
                    FieldMessages: new FieldMessages({}),
                },
                props: {
                    labelTitle: String,
                    labelInfo: String,
                    required: Boolean,
                    validations: {
                        type: Array,
                        default: function() {
                            return [];
                        }
                    }
                },
                computed: {
                    error() {
                        return this.validations.length > 0;
                    },
                },
                template: `
                    <div class="az-group">
                        <slot name="label">
                            <az-label :title="labelTitle" :info="labelInfo" :required="required" :error="error" />
                        </slot>
                        <slot name="input" v-bind:error="error" />
                        <slot name="messages">
                            <az-field-messages :messages="validations" />
                        </slot>
                    </div>
                `
            });

            return component;
        }
    });
});
aztech.use(function(pkg) {


    'use strict';


    pkg.factoryManager.get('app').create({
        name: 'components',
        version: '0.0.1',
        dependencies: [
            'mod.vue',
            'app.alert',
            'app.label',
            'app.dial-field',
            'app.dial-phone-field-bind',
            'app.phone-field',
            'app.field',
            'app.field-group',
            'app.field-messages',
            'app.iconsBase',
            'app.iconsSocial',
            'app.switch',
            'app.tag-group',
            'app.card',
            'app.name-field',
            'app.subfooter',
            'app.pagination',
            'app.search',
            'app.confirm',
            'app.helper',
            'app.select',
            'app.select-autocomplete',
            'app.disclaimer',
            'app.header'
        ],
        setup: function(__shared) {
            return __shared;
        },
        init: function(data, __shared) {
            if(!data) {
                data = {};
            }

            var PUBLIC = this;
            var components = {};

            var Vue = __shared.dependencies['mod.vue'];
            var Alert = __shared.dependencies['app.alert'];
            var Label = __shared.dependencies['app.label'];
            var DialField = __shared.dependencies['app.dial-field'];
            var DialPhoneFieldBind = __shared.dependencies['app.dial-phone-field-bind'];
            var PhoneField = __shared.dependencies['app.phone-field'];
            var Field = __shared.dependencies['app.field'];
            var FieldGroup = __shared.dependencies['app.field-group'];
            var FieldMessages = __shared.dependencies['app.field-messages'];
            var Switch = __shared.dependencies['app.switch'];
            var TagGroup = __shared.dependencies['app.tag-group'];
            var Card = __shared.dependencies['app.card'];
            var NameField = __shared.dependencies['app.name-field'];
            var Subfooter = __shared.dependencies['app.subfooter'];
            var Pagination = __shared.dependencies['app.pagination'];
            var Search = __shared.dependencies['app.search'];
            var Confirm = __shared.dependencies['app.confirm'];
            var Helper = __shared.dependencies['app.helper'];
            var Select = __shared.dependencies['app.select'];
            var SelectAutoComplete = __shared.dependencies['app.select-autocomplete'];
            var Disclaimer = __shared.dependencies['app.disclaimer'];
            var Header = __shared.dependencies['app.header'];

            PUBLIC.alert = new Alert({});
            PUBLIC.label = new Label({});
            PUBLIC.dialField = new DialField({});
            PUBLIC.dialPhoneFieldBind = new DialPhoneFieldBind({});
            PUBLIC.phoneField = new PhoneField({});
            PUBLIC.field = new Field({});
            PUBLIC.fieldGroup = new FieldGroup({});
            PUBLIC.fieldMessages = new FieldMessages({});
            PUBLIC.switch = new Switch({});
            PUBLIC.tagGroup = new TagGroup({});
            PUBLIC.card = new Card({});
            PUBLIC.nameField = new NameField({});
            PUBLIC.subfooter = new Subfooter({});
            PUBLIC.pagination = new Pagination({});
            PUBLIC.search = new Search({});
            PUBLIC.confirm = new Confirm({});
            PUBLIC.helper = new Helper({});
            PUBLIC.select = new Select({});
            PUBLIC.selectAutoComplete = new SelectAutoComplete({});
            PUBLIC.disclaimer = new Disclaimer({});
            PUBLIC.header = new Header({});

            Vue.directive('focus', {
                inserted: function (element, binding) {
                    if(binding.value) {
                        element.focus();  // Focus the element
                    }
                }
            });

            components.alertMixin = PUBLIC.alert.alertMixin;
            components.routeRoot = Vue.component('router-root', {
                template: `<router-view></router-view>
`
            });

            // Creates the root component only if the app is used standalone
            if(document.getElementById('components')) {
                // istanbul ignore next
                PUBLIC.componentsBase = Vue.component('components-base', {
                   mixins: [
                        components.alertMixin
                    ],
                    data: function() {
                        return {
                            alertForm: {
                                name: null,
                                message: null,
                                type: null
                            },
                            active: true,
                            tagGroup: {
                                tags: [
                                    {
                                        "id": 1, "name": "Pop - 1"
                                    },
                                    {
                                        "id": 2, "name": "Anothe one"
                                    },
                                    {
                                        "id": 3, "name": "Edge Rio 123"
                                    },
                                ],
                                options: [
                                    {
                                        "id": 4, "name": "Pop - 2"
                                    },
                                    {
                                        "id": 5, "name": "Teste1"
                                    },
                                    {
                                        "id": 6, "name": "Teste2"
                                    },
                                    {
                                        "id": 7, "name": "Teste3"
                                    },
                                    {
                                        "id": 8, "name": "Teste4"
                                    },
                                    {
                                        "id": 9, "name": "Teste5"
                                    },
                                ],
                            },
                            pageControl: {
                                numPages: 7,
                                current: 1,
                            },
                            searchInput: null,
                            confirmModalToShow: null,
                            selectOptions: [
                                {"id": 1, "name": "Option 1"},
                                {"id": 2, "name": "Option 2"},
                                {"id": 3, "name": "Option 3"},
                                {"id": 4, "name": "Option 4"},
                            ],
                            headerOptions: [
                                {"slug": "request-phase", "text": "Request Phase"},
                                {"slug": "response-phase", "text": "Response Phase"},
                                {"slug": "delete", "text": "Delete"},
                                {"slug": "authorize", "text": "Authorize"}
                            ],
                        };
                    },
                    methods: {
                        createAlert: function() {
                            let alert = {
                                message: this.alertForm.message.value,
                                type: this.alertForm.type
                            };
                            this.pushAlert(null, alert.message, alert.type);
                        },
                        invert: function() {
                            this.active = !this.active;
                        },
                        deleteTag: function(tagID) {
                            let i = 0;
                            for (let tag of this.tagGroup.tags) {
                                if (tag.id === tagID) {
                                    this.tagGroup.tags.splice(i, 1);
                                    break;
                                }
                                i++;
                            }
                        },
                        attachTag: function(optionID) {
                            let i = 0;
                            for (let option of this.tagGroup.options) {
                                if (option.id === optionID) {
                                    this.tagGroup.tags.push(this.tagGroup.options[i]);
                                    break;
                                }
                                i++;
                            }
                        },
                        createTag: function(tagName) {
                            this.tagGroup.tags.push({
                                "id": Math.floor(Math.random() * 100),
                                "name": tagName
                            });
                        },
                        pageSelected: function(page) {
                            this.pageControl.current = page;
                        },
                        searchInputted: function(input) {
                            alert("You searched: " + input);
                        },
                        openConfirmModal: function(type) {
                            this.confirmModalToShow = type;
                        },
                        closeConfirmModal: function() {
                            this.confirmModalToShow = null;
                        }
                    },
                    template:`<section class="components-base" root>
    <az-disclaimer message="Your trial period has expired. Please provide a payment method to continue. <a href='www.google.com'>link</a>"/>

    <div class="content" az-type="wrapper">
        <alert-group :alert-list="alerts" :limit="3" @drop="dropAlert"/>

        <az-name-field name="az-name-field title component"
                       placeholder="Insert a name here"
                       :isTitle="true"
                       :required="true"
                       :validate="true"
                       :focused="true">
        </az-name-field>

        <br>

        <az-name-field name="az-name-field component"
                       placeholder="Insert a name here"
                       :isTitle="false"
                       :required="true"
                       :validate="true"
                       :focused="true">
        </az-name-field>

        <br>
        <br>

        <h2>Fields </h2>

        <br>

        <az-field name="password" label="Password" type="password"/>
        <az-field name="email" label="Email" type="email" />
        <az-field name="text-your" type="text"/>
        <az-field name="text-your" type="textarea"/>

        <div>

            <h3>Required fields:</h3>

            <br>
            <br>

            <az-field name="terms" type="checkbox" required="true">
                I agree to Azion’s <a class="link" href="https://www.azion.com/en/documentation/agreements/tos/">Terms of Services</a>  and
                <a class="link" href="https://www.azion.com/en/documentation/agreements/privacy-policy/">Privacy Policy</a>
            </az-field>

            <br>

            <az-field name="email" label="E-mail" type="email" :validate="true" :required="true" />
            <az-field name="password" label="Password" type="password" :validate="true" info="I believe i can fly!!!" :required="true" />
            <az-field name="Text" label="Just text" type="text" :validate="true" :required="true"/>
        </div>

        <h2>Create an alert below</h2>

        <br>

        <az-field name="alert-message" label="Alert message" type="text" :validate="true" :required="true" v-model="alertForm.message"/>

        <br>

        <h3>Choice one type</h3>

        <label class="input radiobox" for="alert-choice-1">
            <input type="radio" id="alert-choice-1" value="success" v-model="alertForm.type">
            <span>Success</span>
        </label>
        <label class="input radiobox" for="alert-choice-2">
            <input type="radio" id="alert-choice-2" value="error" v-model="alertForm.type">
            <span>Error</span>
        </label>

        <button class="btn" type="submit" @click.prevent="createAlert">Create alert</button>

        <br><br>

        <h3>Switch Field</h3>
        <br>
            <az-switch name="activated" @invert="invert" :active="active" label="Active"></az-switch>
            <br><br>
            <az-switch name="inactivated" :disabled="true" @invert="invert" :active="active" label="Inactive"></az-switch>
        <br>

        <br>

        <h3>Tag Group</h3>
        <br>
        <az-tag-group :tags="tagGroup.tags" :options="tagGroup.options" @deleteTag="deleteTag" @attachTag="attachTag" @createTag="createTag"></az-tag-group>

        <br>

        <h3>Cards</h3>
        <br />
        <az-card><button class="btn">testando</button></az-card>
        <br />
        <h3>CardGroup</h3>
        <br />
        <div class="az-card-group">
            <div class="az-card-group-list">
                <div class="az-card-group-item">
                    <az-card>
                        <img class="logo" src="https://azion-images-development.s3.amazonaws.com/media/001.png" />
                    </az-card>
                </div>
                <div class="az-card-group-item">
                    <az-card>
                        <h3>Titulo</h3>
                        <p :style="{'margin-top': '10px'}">Lorem ipsum</p>
                        <button class="btn" :style="{'margin-top': 'auto'}">botao</button>
                    </az-card>
                </div>
                <div class="az-card-group-item">
                    <az-card>
                        <p>This is a long description just to show how to implement shomething like this</p>
                    </az-card>
                </div>
            </div>
        </div>
    </div>

    <div class="content" az-type="wrapper">
        <h3>Pagination</h3>
        <br>
        <az-pagination :numPages="pageControl.numPages" :currentPage="pageControl.current" @pageSelected="pageSelected"></az-pagination>
        <br>
        <br>
        <h3>Search</h3>
        <br>
        <az-search @search="searchInputted"></az-search>
        <br>
        <br>
        <h3>Confirmation Modal</h3>
        <br>
        <button class="btn" @click.prevent='openConfirmModal("simple")'>Simple</button>
        <button class="btn" @click.prevent='openConfirmModal("full")'>Full</button>
    </div>
    <az-confirm v-if='confirmModalToShow === "simple"'
                title="Confirmation title should be here."
                description="Your confirmation text should be here."
                leaveText="Cancel"
                applyText="Confirm"
                @applyClicked="closeConfirmModal"
                @leaveClicked="closeConfirmModal">
    </az-confirm>
    <az-confirm v-if='confirmModalToShow === "full"'
                title="Confirmation title should be here."
                description='Your confirmation text should be here. Type "confirm" to enable the button.'
                confirmationText="confirm"
                leaveText="Cancel"
                applyText="Confirm"
                @applyClicked="closeConfirmModal"
                @leaveClicked="closeConfirmModal">
    </az-confirm>
    <div class="content" az-type="wrapper">
        <br>
        <br>
        <h3>Helper</h3>
        <br>
        <az-helper>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut
            labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris
            nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate.</p>
            <br>
            <a href="#">See more</a>
        </az-helper>
        <br>
        <br>
        <h3>Select</h3>
        <br>
        <az-select :options="selectOptions"
                   label="Options"
                   :showValidation="true"
                   :required="true"
                   info="Lorem ipsum dolor sit amet, consectetur adipiscing elit.">
        </az-select>
        <br>
        <br>
    </div>
    <br>
    <br>
    <h3 class="content">Header (Common)</h3>
    <az-header-common title="Edge Node" productLabel="beta" documentationLink="http://localhost" buttonText="Actions" :buttonOptions="headerOptions"></az-header-common>
    <br>
    <h3 class="content">Header (Form)</h3>
    <az-header-form title="Azion's Node" subtitle="Edge Node" placeholder="Node name goes here" productLabel="beta"></az-header-form>

    <br>
    <br>

    <az-subfooter buttonText="Save" linkText="Cancel" checkboxLabel="Active"></az-subfooter>
</section>
`,
                });

                // istanbul ignore next
                PUBLIC.app = new Vue({
                    el: '#components'
                });
            }

            return components;
        },
    });
});

